import { useEffect, useRef, useState } from 'react';
import './home.css';
import Sidebar from '../sidebar/sidebar';
import { Carousel } from 'antd';
import hms from '../../assets/images/MY-HMS-min.png';
import farm from '../../assets/images/Farm-master-min.png';
import maintain from '../../assets/images/Mantain-ease-min.png';
import off2on from '../../assets/images/Off2On-min.png';
import post_sales from '../../assets/images/Post-Sales-Connect-min.png';
import property from '../../assets/images/Property-Management-Poster-min.png';
import unified from '../../assets/images/Unified-Corporate-ReportingApplication-min.png';
import swap from '../../assets/images/swap-kart-min.png';
import venue from '../../assets/images/venue-bookings-min.png';
import products from '../../assets/6.png';


const Home = () => {
  const sectionsRef = useRef([]);
  const [currentIndex, setCurrentIndex] = useState(0);  // To track the current section index

  // Function to handle the scrolling effect
  const handleScroll = () => {
    const sections = sectionsRef.current;
    const scrollPosition = window.scrollY; // Get current scroll position
    const windowHeight = window.innerHeight;

    // Calculate the index based on the scroll position and section height
    const index = Math.floor(scrollPosition / windowHeight);

    // Update the current index
    if (index !== currentIndex) {
      setCurrentIndex(index);
    }
  };

  // Add scroll event listener on mount and clean up on unmount
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [currentIndex]);

  return (
    <>
      <div className="home-container">
        <Sidebar />
        <div className="home-content">
          <img
            src={products}
            alt="example"
            className="home-image"
          />
        </div>
      </div>

      <div className="mobile-view">
      <Carousel arrows dotPosition="left" infinite={false}>
      <div>
      <img
            src={farm}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
            src={maintain}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
            src={hms}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
            src={off2on}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
            src={post_sales}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
            src={property}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
            src={swap}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
            src={unified}
            alt="example"
            className="home-image"
          />
      </div>
      <div>
      <img
            src={venue}
            alt="example"
            className="home-image"
          />
      </div>

    </Carousel>
      </div>
    </>
  );
};

export default Home;
